/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	$('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( $(this).innerWidth() / $(this).innerHeight() > 1.5 ) {
			$(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
			$(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$(window).scroll(function() {
		//home page
		if ($(this).scrollTop() > 0) {

			$('.home header.header').addClass('scrolled');
			$('header.header').addClass('scrolled');

		} else {
			
			$('header.header').removeClass('scrolled');
			$('.home header.header').removeClass('scrolled');
			
		}
	});

	// DCA Accordion
	let accBtn = jQuery('.dynamic-accordion-con .accordion-trigger');
	accBtn.on('click', function() {
		var accCon = $(this).parent().next();
		$(this).toggleClass("active");
		accCon.toggleClass("active");
		if($(this).hasClass('active')) {
			$(this).attr('aria-expanded', true);
			accCon.css('height', (accCon.prop('scrollHeight') + 40) + 'px');
		} else {
			$(this).attr('aria-expanded', false);
			accCon.css('height', 0);
		}
	});
}); 

